import { InputHTMLAttributes, MutableRefObject, Ref, useId } from "react";
import classNames from "classnames";
import { useFormContext } from "react-hook-form";

type Props = InputHTMLAttributes<HTMLInputElement> & {
  name: string;
  label?: string;
  containerClassName?: string;
  className?: string;
};

const BaseInput = ({
  name,
  label,
  containerClassName,
  className,
  ...inputProps
}: Props) => {
  const id = useId();
  const formContext = useFormContext();
  const registerFn = formContext?.register;
  const errors = formContext?.formState?.errors || {};
  const error = errors?.[name]?.message as string | undefined;
  const registerData = registerFn ? registerFn(name) : {};
  const { ref: registerRef, ...restRegister } = registerData as {
    ref?: Ref<HTMLInputElement>;
  };

  const setRefs = (el: HTMLInputElement | null) => {
    if (typeof registerRef === "function") {
      registerRef(el);
    } else if (registerRef) {
      (registerRef as MutableRefObject<HTMLInputElement | null>).current = el;
    }
  };

  const fieldClassName = classNames("usadmin-base-input__input", className, {
    error,
  });

  return (
    <div className={classNames("usadmin-base-input", containerClassName)}>
      {label && (
        <label className="usadmin-base-input__label" htmlFor={id}>
          {label}
        </label>
      )}
      <input
        id={id}
        ref={setRefs}
        className={fieldClassName}
        aria-invalid={error ? "true" : "false"}
        aria-errormessage={error ? error : undefined}
        {...restRegister}
        {...inputProps}
      />
      {error && <p className="usadmin-base-input__error">{error}</p>}
    </div>
  );
};

export default BaseInput;
